import React, { Component } from 'react';
import {Toolbar} from 'primereact/components/toolbar/Toolbar';
import {Button} from 'primereact/components/button/Button';
import { get_default_sku } from '../reducers/utils'
import {PRICE_URL, PRICE_URL_PROD} from '../constants';
import {crosssku} from '../reducers/reducer.js'

class AiToolbar extends Component {
    constructor(props) {
       // console.log('toolbar constr') 
        super(props);
    
        this.state = {
          price: null ,
          lastSku:'' //get_default_sku()''
        };
      
        this.componentDidUpdate();
      }
   
    componentDidUpdate() {
        let skus = this.props.sku

        if ([1,2].includes(this.props.cross1))
            skus += ',' + crosssku[this.props.cross1-1]
        if ([1,2].includes(this.props.cross2))
            skus += ',' + crosssku[this.props.cross2+1]
        if ([1,2].includes(this.props.cross3))
            skus += ',' + crosssku[this.props.cross3+3]

        //console.log(this.props.onRefreshReview('title',''))   
       // console.log('toolbar did mount',this.state.lastSku,this.props.sku,skus,this.props.sku, get_default_sku()) 

        if (this.state.lastSku === skus)
            return

        if (this.props.sku === get_default_sku()) {
            this.setState({ price: null, lastSku: skus })
           // return
        }

        //console.log('ran', skus, this.state.lastSku)
        //GETPRICE COMMENTED HERE
  let fetchUrl =PRICE_URL
  if (window.currentEnv ==='www'){
      fetchUrl =PRICE_URL_PROD
  }
  let header = new Headers({
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'multipart/form-data'
        });
  let sentData = {
    method: 'GET', //opt.method,
    mode: 'cors',
    header: header,
  };
 // console.log('fetch',fetchUrl,skus)
  //this.setState({ price: '0',lastSku: this.props.sku })
  //this.props.onRefreshReview('title','') //['refresh_parent'])
  if (skus !=='')
   fetch(fetchUrl + skus, sentData)
      .then(response => {
          if (response.ok) {
              return response.json();
          }
          else {
              this.setState({error: true})
              this.messages.show({
                  severity: 'error',
                  sticky: true,
                  summary: 'Error loading item info: ',
                  detail: 'Cannot load data'
              });
              throw new Error('Something went wrong ...');
          }
      })
      .then(json => {
        if (Object.keys(json).length === 0) {
              this.setState({error: true})
              this.messages.show({
                  severity: 'error',
                  sticky: true,
                  summary: 'Error loading item info: ',
                  detail: 'No load data'
              });
              throw new Error('Something went wrong ...');
                }
                //console.log(this.state.lastSku)
                //json = json['0']
                //console.log(json.flatMap(x => parseFloat(x['p']).toFixed(2)).reduce((a, b) => a + b))
                //console.log(json.flatMap(x => parseFloat(x['p']).toFixed(2)).reduce((a, b) => a + b))
                //let price = json.flatMap(x => parseFloat(x['p'].replace(/,/g, '')).toFixed(2)).reduce((a, b) => a + b)
                let parr  = json.flatMap(x => x['p'].replace(/,/g, ''))
                let price = parr.reduce((a, b) => parseFloat(a) + parseFloat(b))
               // json['esaselected'] = false
                
                //console.log('price esa',json)
                if ('esa' in json[0])
                {
                    this.props.onRefreshReview('esa',json[0]['esa']) 
                    this.props.onRefreshReview('price1',json[0]['p'].replace(',','')) 
                    this.props.onRefreshReview('esadetail',json[0]['esadetail']) 
                    
                }
                 
                this.setState({ price: parseFloat(price).toFixed(2), lastSku: skus })
                //this.state.price = parseFloat(price).toFixed(2);
                //this.state.lastSku = skus;
                this.props.onRefreshReview('refreshReview',json) //json['0']) //['refresh_parent'])
                this.props.onRefreshReview('title',json['0'].refresh_parent.title) //['refresh_parent'])
        })
      }

    
    render() {
        let cartText="Add to Shopping Bag" 
        let bcolor ='ai-bcolor-' + window.currentSite
        //console.log('toolbar render',this.state.lastSku,this.props.sku,this.state.price) 
        if (this.props.size === 'small' || this.props.size === 'medium') {
            cartText = "Add to Bag" 
        }
        let CC = ''
        let cross = ''
        if (this.props.costcard === 'cc') {
            if (crosssku !== undefined) {
                cross = ',' + crosssku.join()
            }
            CC = <Button label="CC" onClick={() => window.location = '//test.thepersonalizedbest.com/fashion_costcard/'+this.props.sku+cross}/>
        }
        let AddButton = ''
        if (this.props.initial !== '') {
            AddButton = ''
        } else if (/* this.props.readyForUserDiamond &&  */this.props.readyForAddToCart && this.props.readyForSession) {
            AddButton = <Button className={bcolor}  label={cartText} onClick={() => this.props.onAddToCart(this.props.urlParams,this.state.price)}/>
        /* } else if (this.props.readyForUserDiamond === false) {
            AddButton = <Button className={bcolor}  label={cartText} onClick={this.props.onNoUserDiamond}/> */
        } else if (this.props.readyForSession === false) {
            AddButton = <Button className={bcolor}  label={cartText} onClick={this.props.onNoSessionMessage}/>
        } else if (this.props.readyForAddToCart === false) {
            // console.log('activated AddB')
            AddButton = <Button className={bcolor}  label={cartText} onClick={this.props.onNoOptionMessage}/>
        }
        // console.log("ADD TO CART TEXT",this.props.readyForSession,this.props.readyForAddToCart)
        let color = 'ai-toolbar-price ai-color-' + window.currentSite

        let crossct = 1 + (this.props.cross1 !== 0 ? 1 : 0) + (this.props.cross2 !== 0 ? 1 : 0) + (this.props.cross3 !== 0 ? 1 : 0)
        //let items = crossct > 1 ? ' (' + crossct + ' Items)' : ''
        let items = ' (' + crossct + ' Item' + (crossct > 1 ? 's)' : ')')
        let price = this.props.initial === '' ? ((this.state.price === undefined || this.state.price === null) ? ' ' : (<div>$<div>{this.state.price}</div><div>{items}</div></div>)) : ' '
        //let price = this.props.initial === '' ? (this.state.price == undefined ? ' ' : ('$' + this.state.price + items)) : ' '
        let toolgroup = 'ai-toolbar-group' + (this.props.initial === '' ? '' : ' ui-toolbar-hide')

        return (<div className={toolgroup}>
        <Toolbar>
        
    <div className="ui-toolbar-group-left">
    <div className={color}>
    {price}
    </div>
    {CC}
    </div>
        
    <div className="ui-toolbar-group-right">
        {AddButton}
    </div>
</Toolbar>
      </div>
        );
    }
}

export default AiToolbar;


// WEBPACK FOOTER //
// ./src/layout/AiToolbar.js